//WE.Flow.Html.Contracts.Manifests.CustomGroupMenuFunctionType
export enum CustomGroupMenuFunctionType {
  SelectPerson=0
}